import {useAsync} from "react-async-hook";
import {$axios} from "../http/axiosInstance";

export const RolesService = {
    GetRoles() {
        return useAsync(async () => {
            return await $axios.get('/roles/');
        }, [])
    }
}